import { ImageList, ImageListServer } from '../store/types';

export const getImgUrl = (id: string | null): typeof id => id === null ? null : `api/v1/img/${id}`;

export const adapteImageList = (res: ImageListServer): ImageList => ({
  count: res.count,
  items: res.items.map((item) => ({
    ...item,
    url: getImgUrl(item.id)
  }))
});

